import { Value } from 'slate'

export default function getDefaultValue(initialText = '') {
  const delimiter = '\n'
  return Value.fromJSON({
    object: 'value',
    document: {
      object: 'document',
      data: {},
      nodes: initialText.split(delimiter).map(line => {
        return {
          type: 'unstyled',
          object: 'block',
          data: {},
          nodes: [
            {
              object: 'text',
              text: line,
              marks: [],
            },
          ],
        }
      }),
    },
    selection: {
      isFocused: true,
    },
  })
}
